import Axios from "axios";
import PostcoderSampleJson from "./postcoder-response.json"

export class PostcoderApi {
    _apiKey = null
    
    constructor(apiKey) {
        this._apiKey = apiKey;
    }
    
    async lookupByPostcode(postcode) {
        return PostcoderSampleJson;
        // let url = "https://ws.postcoder.com/pcw/" 
        //     + this._apiKey 
        //     + "/address/UK/"
        //     + encodeURI(postcode) 
        //     + "?identifier=CMC-PostcoderClientApi&lines=3&exclude=organisation,posttown,county,postcode,country&addtags=longitude,latitude,udprn";
        //
        // return await Axios.get(url)
        //     .then(response => {
        //         return response.data;
        //     })
        //     .catch(error => {
        //         console.error("lookupByPostcode(" + postcode + ") failed :(");
        //     });
    }
}
